import React from 'react';
import { Card, CardContent } from '@/components/ui';

export interface CategoryProgressItem {
  id: string;
  name: string;
  percentage: number;
}

interface CategoryProgressProps {
  items?: CategoryProgressItem[];
  isLoading?: boolean;
}

export function CategoryProgress({ items, isLoading }: CategoryProgressProps) {
  const defaultItems: CategoryProgressItem[] = [
    { id: '1', name: 'Cây xanh', percentage: 75 },
    { id: '2', name: 'Cảnh quan mặt cỏ', percentage: 60 },
    { id: '3', name: 'Hệ thống tưới', percentage: 80 },
    { id: '4', name: 'Lối đi, sân bãi', percentage: 45 },
    { id: '5', name: 'Hệ thống chiếu sáng', percentage: 30 },
    { id: '6', name: 'Tiểu cảnh - Hồ nước', percentage: 20 },
  ];

  const displayItems = items || defaultItems;

  const getProgressColor = (percent: number) => {
    if (percent >= 60) return 'bg-emerald-600';
    if (percent >= 30) return 'bg-orange-500';
    return 'bg-red-500';
  };

  return (
    <Card className="border-none shadow-sm h-full rounded-md">
      <CardContent className="p-3">
        <div className="flex justify-between items-center mb-3">
          <h3 className="text-xs font-bold text-slate-800">Tiến độ thi công theo hạng mục</h3>
          <button className="text-xs font-bold text-emerald-600 hover:underline">Xem chi tiết</button>
        </div>

        <div className="space-y-2">
          {displayItems.map((item) => (
            <div key={item.id} className="space-y-1">
              <div className="flex justify-between items-center">
                <span className="text-xs text-slate-600 font-medium">{item.name}</span>
                <span className="text-xs font-bold text-slate-800">{item.percentage}%</span>
              </div>
              <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                <div 
                  className={`h-full rounded-full transition-all duration-500 ${getProgressColor(item.percentage)}`} 
                  style={{ width: `${item.percentage}%` }} 
                />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
